export default __webpack_public_path__ + "static/media/five-stages.b39cb40c.svg";